import { render, staticRenderFns } from "./UploadStudyMaterialModal.vue?vue&type=template&id=7e05a792"
import script from "./UploadStudyMaterialModal.vue?vue&type=script&lang=js"
export * from "./UploadStudyMaterialModal.vue?vue&type=script&lang=js"
import style0 from "./UploadStudyMaterialModal.vue?vue&type=style&index=0&id=7e05a792&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports